import moment from 'moment';
import { PYMENT } from '../../config/constants/contract';

const formParseScheme = (document, isDraft) => {
  const signerObj = (props) => {
    const body = {
      gender: props.genero ?? null,
      firstName: props.nombre ?? null,
      secondName: props.segundoNombre ?? null,
      lastName: props.apellido ?? null,
      mLastName: props.segundoApellido ?? null,
      rut: props.rut ?? null,
      nationality: props.nacionalidad ?? null,
      civilStatus: props.estadoCivil ?? null,
      profession: props.profesion ?? null,
      address: props.direccion ?? null,
      commune: props.comuna ?? null,
      email: props.email ?? null,
      confirmEmail: props.email ?? null,
      phonePrefix: props.telefono
        ? props.telefono.substring(0, props.telefono.indexOf(' '))
        : '+56',
      phoneNumber: props.telefono
        ? props.telefono.substring(props.telefono.indexOf(' ') + 1)
        : '',
      hasLegalPerson: props.personaJuridica ? true : false,
    };

    if (props.personaJuridica) {
      body.companyCreationMethod = props.personaJuridica.eud ?? null;
      body.businessName = props.personaJuridica.razon ?? null;
      body.giro = props.personaJuridica.giro ?? null;
      body.companyRol = props.personaJuridica.rut ?? null;
      body.dateOfconstitution = props.personaJuridica.fechaPoder
        ? moment(props.personaJuridica.fechaPoder)
        : null;
      body.powerCert = props.personaJuridica.certificadoPoder ?? null;
      if (!props.personaJuridica.eud) {
        body.constitutionNotary = props.personaJuridica.notarioPoder ?? null;
      }
    }
    return body;
  };

  const data = {
    editForm: !isDraft ?? true,
    citySign: document.lugar ?? null,
    dateSign: document.fecha ? moment(document.fecha) : null,
    lessor: [signerObj(document.arrendador)],
    lessee: [signerObj(document.arrendatario)],
    codebtor: [''],
    hasCodebtor: document.codeudor ? true : false,
    initialLeaseDate: document.arriendo.fecha
      ? moment(document.arriendo.fecha)
      : null,
    contractDurationNumber: document.arriendo.duracion
      ? document.arriendo.duracion.split(' ')[0]
      : null,
    contractDurationRange: document.arriendo.duracion
      ? document.arriendo.duracion.split(' ')[1]
      : null,
    paymentPeriod: document.arriendo.periodoPago ?? null,
    autoRenewal: document.arriendo.autorenovacion ?? null,
    typeOfCurrency: document.arriendo.tipoCambio ?? null,
    monthlyRent: document.arriendo.montoMensual ?? null,
    guaranteeAmount: document.arriendo.montoGarantia ?? null,
    finesType: document.arriendo.tipoCambioMulta ?? false,
    sanction: document.arriendo.sancion ?? null,
    petBan: document.arriendo.prohibeAnimales ?? null,
    payCommonExpenses: document.arriendo.gastosComunes ?? false,
    rentAdjustment: document.arriendo.tipoReajuste ?? false,
    typeOfHousing: document.inmueble.tipo ?? null,
    homeAddress: document.inmueble.direccion ?? null,
    homeCommune: document.inmueble.comuna ?? null,
    hasParking:
      document.inmueble.listaEstacionamiento &&
      document.inmueble.listaEstacionamiento[0]
        ? true
        : false,
    hasWarehouse:
      document.inmueble.listaBodega && document.inmueble.listaBodega[0]
        ? true
        : false,
    paymentType: document.tipoPago ?? null,
    owner: document.owner ?? null,
  };

  if (document.codeudor) {
    data.codebtor[0] = signerObj(document.codeudor);
  }

  if (document.arrendatarios && document.arrendatarios[0]) {
    document.arrendatarios?.forEach((signer, i) =>
      data.lessee.push({ docIx: i, ...signerObj(signer) })
    );
  }

  if (document.codeudores && document.codeudores[0]) {
    document.codeudores?.forEach((signer, i) =>
      data.codebtor.push({ docIx: i, ...signerObj(signer) })
    );
  }

  data.parking = data.hasParking
    ? document.inmueble.listaEstacionamiento.map((item) => ({ number: item }))
    : [''];

  data.warehouse = data.hasWarehouse
    ? document.inmueble.listaBodega.map((item) => ({ number: item }))
    : [''];

  if (data.finesType) {
    data.finesAmount = document.arriendo.montoPenalizacion ?? null;
  }

  if (data.rentAdjustment) {
    if (document.arriendo.tipoReajuste === 'porcentaje') {
      data.readjustmentValue = document.arriendo.periodoReajuste
        ? document.arriendo.periodoReajuste.split(' ')[1]
        : null;
      data.readjustmentRange = document.arriendo.periodoReajuste
        ? document.arriendo.periodoReajuste.split(' ')[2]
        : null;
      data.percentAdjustment = document.arriendo.montoReajuste ?? null;
    }
    if (document.arriendo.tipoReajuste === 'ipc') {
      data.IPCAdjustment = document.arriendo.periodoReajuste ?? null;
    }
  }

  if (document.tipoPago === PYMENT.TRANSFER) {
    data.holdersName = document.cuentaPago.nombre ?? null;
    data.holdersRut = document.cuentaPago.rut ?? null;
    data.notificationEmail = document.cuentaPago.email ?? null;
    data.bank = document.cuentaPago.banco ?? null;
    data.typeBankAccount = document.cuentaPago.tipoCuenta ?? null;
    data.accountNumber = document.cuentaPago.numeroCuenta ?? null;
  }

  return data;
};

export default formParseScheme;
